interface ControlHandlerInput {
  handler: () => void;
  isTeamsMounted: boolean;
}

interface MountedTeamControlHandlersInput {
  isTeamsMounted: boolean;
  onDeployTeam: () => void;
  onInspectTeam: () => void;
  onNext: () => void;
  onPrevious: () => void;
}

interface MountedTeamControlHandlers {
  onDeployTeam?: () => void;
  onInspectTeam?: () => void;
  onNext?: () => void;
  onPrevious?: () => void;
}

function getMountedTeamHandler({
  handler,
  isTeamsMounted,
}: ControlHandlerInput): (() => void) | undefined {
  if (!isTeamsMounted) {
    return undefined;
  }

  return handler;
}

export function getMountedTeamControlHandlers({
  isTeamsMounted,
  onDeployTeam,
  onInspectTeam,
  onNext,
  onPrevious,
}: MountedTeamControlHandlersInput): MountedTeamControlHandlers {
  return {
    onDeployTeam: getMountedTeamHandler({
      handler: onDeployTeam,
      isTeamsMounted,
    }),
    onInspectTeam: getMountedTeamHandler({
      handler: onInspectTeam,
      isTeamsMounted,
    }),
    onNext: getMountedTeamHandler({ handler: onNext, isTeamsMounted }),
    onPrevious: getMountedTeamHandler({
      handler: onPrevious,
      isTeamsMounted,
    }),
  };
}
